export default "__VITE_ASSET__aDMczxRV__"